import React from "react";
import "./layout.css";
import { Routes, Route } from "react-router-dom";
import Home from "../Admin/Home/Home";
import Login from "../Admin/Login/Login";

import ProtectedRoutes from "../Admin/ProtectedRoutes/ProtectedRoutes";
// import Dashboard from "../Admin/Dashboard/Dashboard";
import PageNotFound from "../Admin/PageNotFound/PageNotFound";

import Inspirations from "../Admin/Inspirations/Inspirations";
import AddInspirations from '../Admin/Inspirations/AddInspirations'
import EditInspiration from "../Admin/Inspirations/EditInspiration";

import Styles from "../Admin/Styles/Styles";
import AddStyles from "../Admin/Styles/AddStyles";
import ViewStyle from "../Admin/Styles/ViewStyle";
import EditStyle from "../Admin/Styles/EditStyle";

import Tattoos from "../Admin/Tattoo/Tattoos";
import AddTattoo from "../Admin/Tattoo/AddTattoos";
import ViewTattoo from "../Admin/Tattoo/ViewTattoo";
import EditTattoo from "../Admin/Tattoo/EditTattoo";

import TextToImages from "../Admin/TextToImages/TextToImages";
import TattooGenerator from "../Admin/TextToImages/TattooGenerator";

import ChangePassword from "../Admin/Login/ChangePassword";
import GenerateThumb from "../Admin/GenerateThumb/GenerateThumb";
import ImageUpload from "../Admin/ImageUpload/ImageUpload";


const Routing = () => {

  return (
    <>
      {/* auth routes */}
      <Routes>
        <Route exact={true} path="/login" element={<Login />} />
        <Route exact={true} path="*" element={<PageNotFound />} />

        {/* protected routes */}

        <Route
          exact={true}
          path="/"
          element={<ProtectedRoutes Component={Home} />}
        />

        <Route
          exact={true}
          path="/dashboard"
          element={<ProtectedRoutes Component={Home} />}
        />

        <Route
          exact
          path="/inspirations"
          element={<ProtectedRoutes Component={Inspirations} />}
        />

        <Route
          exact
          path="/Inspirations/create"
          element={<ProtectedRoutes Component={AddInspirations} />}
        />

        <Route
          exact
          path="/Inspirations/:id/edit"
          element={<ProtectedRoutes Component={EditInspiration} />}
        />


        <Route
          exact
          path="/styles"
          element={<ProtectedRoutes Component={Styles} />}
        />
        <Route
          exact
          path="/styles/add"
          element={<ProtectedRoutes Component={AddStyles} />}
        />
        <Route
          exact
          path="/styles/:id"
          element={<ProtectedRoutes Component={ViewStyle} />}
        />
        <Route
          exact
          path="/styles/:id/edit"
          element={<ProtectedRoutes Component={EditStyle} />}
        />

        <Route
          exact
          path="/tattoos"
          element={<ProtectedRoutes Component={Tattoos} />}
        />
        <Route
          exact
          path="/tattoos/add"
          element={<ProtectedRoutes Component={AddTattoo} />}
        />
        <Route
          exact
          path="/tattoos/:id"
          element={<ProtectedRoutes Component={ViewTattoo} />}
        />
        <Route
          exact
          path="/tattoos/edit/:id"
          element={<ProtectedRoutes Component={EditTattoo} />}
        />

        <Route
          exact
          path="/tattoo-generator"
          element={<ProtectedRoutes Component={TattooGenerator} />}
        />
        <Route
          exact
          path="/tattoo-generator/add"
          element={<ProtectedRoutes Component={TattooGenerator} />}
        />

        <Route
          exact
          path="/changepassword"
          element={<ProtectedRoutes Component={ChangePassword} />}
        />

        <Route
          exact
          path="/generate-thumb"
          element={<ProtectedRoutes Component={GenerateThumb} />}
        />


        <Route
          exact
          path="/image-upload"
          element={<ProtectedRoutes Component={ImageUpload} />}
        />

        <Route
          exact
          path="/texttoimages"
          element={<ProtectedRoutes Component={TextToImages} />}
        />

      </Routes>
    </>
  );
};
export default Routing;
